import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chevron-right\">\r\n<defs><style type=\"text/css\"></style></defs>\r\n<path d=\"M448 725.333333a42.666667 42.666667 0 0 1-30.293333-12.373333 42.666667 42.666667 0 0 1 0-60.586667L558.933333 512 423.253333 370.773333a42.666667 42.666667 0 0 1 0-60.16 42.666667 42.666667 0 0 1 60.586667 0l164.693333 170.666667a42.666667 42.666667 0 0 1 0 59.733333l-170.666666 170.666667a42.666667 42.666667 0 0 1-29.866667 13.653333z\" p-id=\"2530\" fill=\"#6777ef\">\r\n</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chevron-right.svg
// module id = I1IY
// module chunks = 16